module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"cancel":"Cancelar","delete":"Eliminar"},"en":{"cancel":"Cancel","delete":"Delete"}}')
  delete Component.options._Ctor
}
